import Vue from "vue";
import FormBuilder from "@/components/forms/FormBuilder";
import ITable from "@/components/table/ITable";
import VueMeta from "vue-meta";

Vue.component('FormBuilder', FormBuilder)
Vue.component('ITable', ITable)
Vue.use(VueMeta)
